import Api from "../Api";

export const addInfluencer = (influencerData) => {
  return Api.post("user/influencers", influencerData).then((res) => res.data);
};

export const getInfluencers = () => {
  return Api.get("user/influencers").then((res) => res.data);
};

export const updateInfluencerStatus = (id, status) => {
  return Api.patch("user/influencers/" + id, { status }).then(
    (res) => res.data
  );
};

export const getInfluencerDetails = (id) => {
  return Api.get("user/influencers/" + id).then((res) => res.data);
};

export const assignProductsToInfluencer = (id, productIds) => {
  return Api.post("user/influencers/" + id, { productIds }).then(
    (res) => res.data
  );
};

export const getInfluencersForProducts = (id) => {
  return Api.get("user/influencers/product/" + id).then((res) => res.data);
};

export const getInfluencerOrderDetails = (id, startDate = '', endDate = '') => {
  return Api.get("user/influencers/orders/" + id + "?startDate=" + startDate + "&endDate=" + endDate).then((res) => res.data);
};
